import { toString } from 'lodash';
import ILoginResponse from 'types/auth/ILoginResponse';
import IToken from 'types/auth/IToken';

export const fromLoginResponseToToken = (data: ILoginResponse): IToken => {
  return {
    token: toString(data?.token),
    role: toString(data?.role),
    hasMultifactor: data?.hasMultifactor,
    needsReset: data?.needsReset,
    requiresMfaEnrollment: data?.requiresMfaEnrollment,
    requiresMfaChallenge: data?.requiresMfaChallenge,
    // Deliberately not toString(): an absent mfaToken must stay null, not become ''.
    mfaToken: data?.mfaToken ?? null,
    isMfaEnrolled: data?.isMfaEnrolled,
    // Deliberately not toString(): null is meaningful here — it says MFA is mandatory *now*, not that
    // no date will ever apply — and '' would read as "no date configured" to every consumer.
    mfaMandatoryFrom: data?.mfaMandatoryFrom ?? null,
    showMfaEnrollmentBanner: data?.showMfaEnrollmentBanner,
    // Deliberately not defaulted to 0: only the backup-code endpoint populates this, and 0 there
    // means "that was your last code" — the one branch with its own copy. Collapsing absent into 0
    // would fire that warning after every ordinary login.
    remainingBackupCodes: data?.remainingBackupCodes ?? null,
  };
};
